export default __webpack_public_path__ + "static/media/20.00143292.png";